import axios from "axios";

export const envioNotificacionMayoristas = (entidad) =>{

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/ac09aa98-e250-495f-80c5-6cc5041837f4', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/f5962b20-89fb-4411-b57e-6dc1fd856e8f',
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });

}